import React from "react";
// react plugin used to create google maps
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  CardTitle,
  FormGroup,
  Input,
  Button,
  Label
} from "reactstrap";

import firebase from "firebase.config";
import DatePicker from "react-datepicker";
import axios from 'axios'
import NewsletterPhonePreview from "components/NewsletterPhonePreview";

import "react-datepicker/dist/react-datepicker.css";
export default class CreateMagazine extends React.Component {
  state = {
    enable: true,
    isEmpty: true,
    pageNames: ["", "", ""],

    magazine: [
      {
        date: "",
        noOfWeeks: 1,
        image: null,
        text: "",

        headers: [
          {
            header: "",
            rows: [
              {
                column1: "",
                column2: ""
              }
            ]
          }
        ]
      }
    ]
  };

  checkIfEmpty = async page => {
    var temp = this.state.magazine[0];


    // let oldDates = Object.keys(this.props.newsletters).map(d => d.split("+")[0])
    // console.warn("Old Dates", oldDates)

    // if (!temp.date || !temp.noOfWeeks || !temp.image || !temp.headers) {
    console.warn("BITRUPT", temp.date, temp.noOfWeeks, temp.headers)
    // if (!temp.date || !temp.noOfWeeks || !temp.headers) {
    if (!temp.date || !temp.headers) {
      console.warn(!temp.date, !temp.noOfWeeks, !temp.headers)
      this.alertTheUser();
      return;
    }
    if (this.props.newsletters)
      if (this.props.newsletters[temp.date + "+" + temp.noOfWeeks] && !this.props.edit) {
        alert("You have already posted a newsletter on selected date");
        return
      }
    if (temp.headers) {
      await temp.headers.map(tableArray => {
        // console.log("Reached First Map Function");
        if (!tableArray.header || !tableArray.rows) {
          this.alertTheUser();
          // console.log("Returned Header/Row");
          return;
        } else if (tableArray.rows) {
          tableArray.rows.map(row => {
            // console.log("Reached Second Map Function");
            if (!row.column1 || !row.column2) {
              this.alertTheUser();
              // console.log("Returned Column1/2");
              return;
            }
          });
        }
      });
    }
    this.routeToNextPage(page);
  };

  routeToNextPage = page => {
    this.props.changePage(this.state.magazine, page);
  };

  alertTheUser = () => {
    alert("All fields are required");
    return;
  };

  componentDidMount = () => {
    this.initialize();
    console.warn("EXISTING NEWSLETTERS", this.props.newsletters)
  };

  initialize = () => {
    console.log("Page 1:");
    console.log("Global Props: ", this.props);

    var temp = this.state.magazine;
    // temp[0].date = new Date().getTime();
    // temp[0].noOfWeeks = new Date().getWeekOfMonth();
    console.log("For Date and No. of Weeks:", this.props.obj);
    temp[0].date = this.props.obj[0].date;
    temp[0].noOfWeeks = this.props.obj[0].noOfWeeks;
    temp[0].image = this.props.obj[0].magazine1.page1.image;
    temp[0].text = this.props.obj[0].magazine1.page1.imageText;
    temp[0].headers = this.props.obj[0].magazine1.page1.tableArray;

    this.setState({
      magazine: temp,
      pageNames: this.props.pageNames
    });

    console.log("Local Obj: ", this.state.magazine);
  };

  addImage = async event => {
    this.setState({
      enable: false
    });

    var temp = this.state.magazine;
    temp[0].imageTemp = event.target.files[0];

    this.setState({
      data: temp
    });

    console.log("Image To Be Uploaded!");

    await this.savePage1Image();
    this.setState({
      enable: true
    });
  };

  savePage1Image = async () => {
    let temp = this.state.magazine;
    let file = temp[0].imageTemp;

    if (file) {
      var min = 1;
      var max = 100;
      var rand = min + Math.random() * (max - min);

      var filename =
        this.props.obj[0].date +
        "+" +
        this.props.obj[0].noOfWeeks +
        "+" +
        "page1" +
        "+" +
        rand;

      const storage = firebase.storage().ref();
      const image = storage.child(filename);

      await image.put(file).then(async snapshot => {
        await image.getDownloadURL().then(async url => {
          console.log("Image URL:", url);
          temp[0].image = url;
          delete temp[0].imageTemp;
          this.setState({
            magazine: temp
          });
        });
      });
      console.log("Image Uploaded!!!");
    }
  };

  addHeader = () => {
    var temp = this.state.magazine;

    temp[0].headers.push({
      header: "",
      rows: [{ column1: "", column2: "" }]
    });

    this.setState({
      magazine: temp
    });
  };

  addRow = index => {
    let temp = this.state.magazine;

    temp[0].headers[index].rows.push({
      column1: "",
      column2: ""
    });

    this.setState({
      magazine: temp
    });
  };

  removeRow = (index, indexInner) => {
    let temp = this.state.magazine;

    temp[0].headers[index].rows.splice(indexInner, 1);

    this.setState({
      magazine: temp
    });
  };

  handleDatechange = async event => {
    let temp = this.state.magazine;
    console.warn("SELECTED DATE", event.target.value.toString())
    temp[0].date = event.target.value.toString();

    // axios.get("https://us-central1-bitrupt-bot.cloudfunctions.net/getWeekNumber?date=" + temp[0].date).then(res => {
    //   console.warn("response is", res.data)
    //   temp[0].noOfWeeks = res.data;

    // })
    //   .catch(err => {
    //     temp[0].noOfWeeks = this.handleWeekchange(temp[0].date);

    //   })
    temp[0].noOfWeeks = this.handleWeekchange(temp[0].date);


    // for week number
    const proxyurl = "https://cors-anywhere.herokuapp.com/";
    const url = "https://us-central1-bitrupt-bot.cloudfunctions.net/getWeekNumber?date=" + temp[0].date; // site that doesn’t send Access-Control-*
    await fetch(proxyurl + url)
      .then(response => response.text())
      .then(contents => {
        console.warn(JSON.parse(contents).weekNum)
        temp[0].noOfWeeks = JSON.parse(contents).weekNum;
        console.warn("Fetched week is", temp[0].noOfWeeks)
      })
      .catch(() => {
        temp[0].noOfWeeks = this.handleWeekchange(temp[0].date);
      })


    // console.warn("Weeek is", temp[0].noOfWeeks)
    // console.warn(event.target.value.toString())
    // console.warn(new Date(event.target.value.toString()).toDateString())
    this.setState({
      magazine: temp
    });
    console.log("Date:", this.state.magazine);
  };


  handleDatechange2 = event => {
    let temp = this.state.magazine;
    let date = new Date(event)
    let dateString = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    let dateString2 = date.getFullYear() + "-0" + (date.getMonth() + 1) + "-0" + date.getDate()
    console.warn(dateString2)
    temp[0].date = dateString2
    temp[0].noOfWeeks = 0

    this.setState({
      magazine: temp
    });
    console.log("Date:", this.state.magazine);
  };

  handleWeekchange = date => {
    console.warn("DATEEE", date)
    // console.warn("week change", date)
    var temp = date.split("-")[0] + "-" + date.split("-")[1] + "-" + "1";
    console.warn(temp)
    var firstWeekday = new Date(temp).getDay();
    console.warn(firstWeekday)

    // take 1st day of week, take the date out from string
    // subtract 1 because it's already counted in 1st day
    // divide by 7 (no of days in a week)
    // add 1 because current form represents '1' as '0'
    // overall parseInt to convert into integer if float
    var weekNo =
      parseInt((firstWeekday + (parseInt(date.split("-")[2]) - 1)) / 7) + 1;
    console.warn(weekNo)


    // console.warn("WEEK NO", weekNo)

    let dateStored = new Date(date)
    let day = new Date(date).getDay()

    let firstOfMonth = new Date(date)
    firstOfMonth.setDate(1)

    if (firstOfMonth.getDay() === 0) {
      console.warn("Case 1")

      // console.warn("Simple case")
      return weekNo;

    }
    else if (dateStored.getDate() - day <= 0 && day !== 0) {
      console.warn("Condition fulfilled")
      //get last week of previous month
      let prevMonthSunday = new Date(dateStored);
      prevMonthSunday.setDate(prevMonthSunday.getDate() - day)
      let weekNum = this.handleWeekChangeFromDate(prevMonthSunday)

      // console.warn("DATE is", prevMonthSunday.toISOString(), "Weeek Num", weekNum)
      return weekNum;
    }
    else {
      console.warn("Case 3")

      return weekNo - 1
    }
    // console.warn("DAY No", day)



    // return weekNo;
  };

  handleWeekChangeFromDate = date => {
    var firstWeekday = date.getDay();

    // take 1st day of week, take the date out from string
    // subtract 1 because it's already counted in 1st day
    // divide by 7 (no of days in a week)
    // add 1 because current form represents '1' as '0'
    // overall parseInt to convert into integer if float
    var weekNo =
      parseInt((firstWeekday + (parseInt(date.getDate()) - 1)) / 7) + 1;

    return weekNo;

  }



  weekCount = (year, month_number) => {

    // month_number is in the range 1..12

    var firstOfMonth = new Date(year, month_number - 1, 1);
    var lastOfMonth = new Date(year, month_number, 0);

    var used = firstOfMonth.getDay() + lastOfMonth.getDate();

    return Math.ceil(used / 7);
  }


  getWeekOfMonth = (date) => {

    // let day = date.getDate()
    // day -= (date.getDay() == 0 ? 6 : date.getDay() - 1);//get monday of this week
    // //special case handling for 0 (sunday)

    // day += 7;
    // //for the first non full week the value was negative

    // let prefixes = ['0', '1', '2', '3', '4', '5'];
    // return prefixes[0 | (day) / 7];
    //sunday is 0

    let day = date.getDay()
    console.warn(day)

    return 0;
  }

  // handleWeekchange = event => {
  //   let temp = this.state.magazine;

  //   temp[0].noOfWeeks = event.target.value.toString();

  //   this.setState({
  //     magazine: temp
  //   });
  // };

  handleTextChange = event => {
    let temp = this.state.magazine;

    temp[0].text = event.target.value;

    this.setState({
      magazine: temp
    });
  };

  handleHeadingChange = (event, index) => {
    let temp = this.state.magazine;

    temp[0].headers[index].header = event.target.value;

    this.setState({
      magazine: temp
    });
  };

  handleColumnChange = (event, index, indexInner, col1) => {
    let temp = this.state.magazine;

    col1
      ? (temp[0].headers[index].rows[indexInner].column1 = event.target.value)
      : (temp[0].headers[index].rows[indexInner].column2 = event.target.value);

    this.setState({
      magazine: temp
    });
  };

  setPageNames = (event, index) => {
    var temp = this.state.pageNames;

    temp[index] = event.target.value;
    console.log("Page " + index + ":", event.target.value);
    console.log("Temp:", temp);

    this.setState(
      {
        pageNames: temp
      },
      () => {
        this.props.setPageTitles(this.state.pageNames);
      }
    );
  };

  getDate = () => {
    if (this.state.magazine[0].date.length > 0) {
      console.warn("Case 1")
      return new Date(this.state.magazine[0].date)
    }
    else if (this.props.obj[0].date) {
      let d = this.props.obj[0].date
      console.warn("Case 2")

      if (d.split("-").length === 3) {
        console.warn("Case 2-1")
        return new Date()
      }
      else {
        console.warn("Case 2-2")

        return new Date(d)
      }
    }
    else {
      console.warn("Case 3")

      return new Date()
    }
    // console.warn("Get date called")
    // if (d.split("-").length === 3) {
    //   console.warn("Length 333")
    //   return new Date()
    // }
    // else {
    //   return new Date(d)
    // }

  }

  // ----- Tailwind 공통 스타일 (초보자도 한눈에 보기 쉽게) -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  // 단계 표시기 (현재는 1단계: 기본 정보 입력)
  renderSteps() {
    const steps = ["기본 정보", "본문 내용", "마무리 확인"];
    const current = 0;
    return (
      <ol className="mb-8 flex flex-wrap items-center gap-3">
        {steps.map((label, i) => (
          <li key={i} className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <span
                className={
                  "flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold " +
                  (i === current
                    ? "bg-sky-500 text-white shadow"
                    : "bg-gray-200 text-gray-500")
                }
              >
                {i + 1}
              </span>
              <span
                className={
                  "text-sm font-medium " +
                  (i === current ? "text-sky-600" : "text-gray-400")
                }
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <span className="hidden h-px w-8 bg-gray-300 sm:block" />
            )}
          </li>
        ))}
      </ol>
    );
  }

  render() {
    const mag = this.state.magazine[0];
    const portions = this.props.obj[0].magazine1.page1.tableArray;
    return (
      <div className="content">
        <div className="mx-auto w-full max-w-6xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-2 text-2xl font-bold">📰 새 뉴스레터 만들기</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              처음이신가요? 걱정 마세요. 아래 순서대로 칸을 채우기만 하면 됩니다.
              <br />
              <span className="font-semibold">① 기본 정보</span>를 입력하고,{" "}
              <span className="font-semibold">② 내용 항목</span>을 추가한 뒤,{" "}
              화면 아래 <span className="font-semibold">[다음 단계로]</span> 버튼을
              누르세요.
            </p>
          </div>

          {/* 단계 표시기 */}
          {this.renderSteps()}

          <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
            <div className="min-w-0 lg:flex-1">
          {/* 1. 페이지 제목 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                1
              </span>
              <h3 className="text-lg font-bold text-gray-800">페이지 제목</h3>
            </div>
            <p className="mb-4 ml-9 text-sm text-gray-500">
              뉴스레터는 3개의 페이지(탭)로 구성됩니다. 독자가 보게 될 각 페이지의
              이름을 정해주세요. 예) 이번 주 소식 · 행사 안내 · 공지사항
            </p>
            <div className="ml-9 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {[0, 1, 2].map(i => (
                <div key={i}>
                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    {i + 1}번 페이지 제목
                  </label>
                  <input
                    type="text"
                    placeholder={`예) ${["이번 주 소식", "행사 안내", "공지사항"][i]}`}
                    defaultValue={this.state.pageNames[i]}
                    className={this.inputCls}
                    onChange={event => this.setPageNames(event, i)}
                  />
                </div>
              ))}
            </div>
          </section>

          {/* 2. 기본 정보 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                2
              </span>
              <h3 className="text-lg font-bold text-gray-800">기본 정보</h3>
            </div>
            <p className="mb-4 ml-9 text-sm text-gray-500">
              뉴스레터의 발행 날짜와 맨 위에 보여줄 대표 이미지, 인사말을
              입력하세요.
            </p>

            <div className="ml-9 space-y-5">
              {/* 날짜 */}
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  발행 날짜 <span className="text-rose-500">*</span>
                </label>
                <input
                  type="date"
                  placeholder="날짜 선택"
                  defaultValue={this.props.obj[0].date}
                  required
                  disabled={this.props.edit ? true : false}
                  className={
                    this.inputCls +
                    " max-w-xs" +
                    (this.props.edit ? " cursor-not-allowed bg-gray-100 text-gray-400" : "")
                  }
                  onChange={event => this.handleDatechange(event)}
                />
                <p className="mt-1 text-xs text-gray-400">
                  달력에서 발행할 날짜를 선택하면 몇 주차인지 자동으로
                  계산됩니다.
                </p>
              </div>

              {/* 대표 이미지 */}
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  대표 이미지
                </label>
                <div className="flex flex-col items-start gap-4 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-4 sm:flex-row sm:items-center">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={ref => (this.myInput = ref)}
                    onChange={event => this.addImage(event)}
                  />
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 rounded-lg bg-sky-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-600"
                    onClick={() => this.myInput.click()}
                  >
                    🖼️ 이미지 선택
                  </button>
                  {mag.image ? (
                    <img
                      src={mag.image}
                      alt="대표 이미지 미리보기"
                      className="h-20 w-20 rounded-lg object-cover shadow"
                    />
                  ) : (
                    <span className="text-xs text-gray-400">
                      아직 이미지를 선택하지 않았어요. (선택 사항)
                    </span>
                  )}
                </div>
              </div>

              {/* 인사말 / 제목 문구 */}
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  대표 문구 (인사말)
                </label>
                <textarea
                  rows={3}
                  placeholder="예) 안녕하세요! 이번 주 소식을 전해드립니다."
                  defaultValue={this.props.obj[0].magazine1.page1.imageText}
                  className={this.inputCls + " resize-y"}
                  onChange={event => this.handleTextChange(event)}
                />
                <p className="mt-1 text-xs text-gray-400">
                  뉴스레터 맨 위 대표 이미지 아래에 보여질 짧은 인사말입니다.
                </p>
              </div>
            </div>
          </section>

          {/* 3. 내용 항목 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                3
              </span>
              <h3 className="text-lg font-bold text-gray-800">내용 항목</h3>
            </div>
            <p className="mb-4 ml-9 text-sm text-gray-500">
              뉴스레터에 담을 내용을 <b>항목</b> 단위로 추가하세요. 항목마다
              <b> 소제목</b>과 <b>여러 줄의 내용</b>을 넣을 수 있습니다. 예) 소제목
              "이번 주 행사" → 왼쪽 칸에 행사 이름, 오른쪽 칸에 설명.
            </p>

            {portions.length === 0 && (
              <div className="ml-9 mb-4 rounded-xl bg-amber-50 p-4 text-sm text-amber-700">
                아직 추가된 내용 항목이 없습니다. 아래 <b>[+ 내용 항목
                추가]</b> 버튼을 눌러 첫 번째 항목을 만들어 보세요.
              </div>
            )}

            <div className="ml-0 space-y-5 sm:ml-9">
              {portions.map((table, index) => (
                <div
                  key={index}
                  className="rounded-xl border border-gray-200 bg-gray-50/60 p-4"
                >
                  <div className="mb-3 flex items-center gap-2">
                    <span className="rounded-md bg-sky-500 px-2 py-0.5 text-xs font-bold text-white">
                      항목 {index + 1}
                    </span>
                  </div>

                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    소제목
                  </label>
                  <input
                    type="text"
                    placeholder="예) 이번 주 주요 행사"
                    defaultValue={table.header}
                    className={this.inputCls + " mb-3"}
                    onChange={event => this.handleHeadingChange(event, index)}
                  />

                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    내용 (왼쪽: 제목 / 오른쪽: 설명)
                  </label>
                  <div className="space-y-2">
                    {table.rows.map((row, indexInner) => (
                      <div
                        key={indexInner}
                        className="flex flex-col gap-2 sm:flex-row sm:items-start"
                      >
                        <textarea
                          rows={2}
                          placeholder="예) 봄맞이 바자회"
                          value={row.column1}
                          required
                          className={this.inputCls + " flex-1 resize-y"}
                          onChange={event =>
                            this.handleColumnChange(event, index, indexInner, true)
                          }
                        />
                        <textarea
                          rows={2}
                          placeholder="예) 5월 3일 오후 2시, 1층 로비"
                          value={row.column2}
                          required
                          className={this.inputCls + " flex-1 resize-y"}
                          onChange={event =>
                            this.handleColumnChange(event, index, indexInner, false)
                          }
                        />
                        <button
                          type="button"
                          title="이 줄 삭제"
                          className="inline-flex shrink-0 items-center justify-center rounded-lg border border-rose-200 bg-white px-3 py-2 text-sm font-medium text-rose-500 transition hover:bg-rose-50"
                          onClick={() => this.removeRow(index, indexInner)}
                        >
                          🗑️ 삭제
                        </button>
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    className="mt-3 inline-flex items-center gap-1 rounded-lg border border-dashed border-sky-300 bg-white px-3 py-2 text-sm font-medium text-sky-600 transition hover:bg-sky-50"
                    onClick={() => this.addRow(index)}
                  >
                    + 줄 추가
                  </button>
                </div>
              ))}
            </div>

            <button
              type="button"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl border-2 border-dashed border-sky-300 bg-sky-50 px-4 py-3 text-sm font-bold text-sky-600 transition hover:bg-sky-100 sm:ml-9 sm:w-auto"
              onClick={() => this.addHeader()}
            >
              + 내용 항목 추가
            </button>
          </section>
            </div>

            {/* 실시간 앱 미리보기 */}
            <div className="w-full lg:w-[340px] lg:shrink-0">
              <div className="lg:sticky lg:top-4">
                <NewsletterPhonePreview
                  pageNames={this.state.pageNames}
                  date={mag.date}
                  noOfWeeks={mag.noOfWeeks}
                  magazine={{
                    page1: {
                      image: mag.image,
                      imageText: mag.text,
                      tableArray: mag.headers
                    },
                    page2: this.props.obj[0].magazine1.page2,
                    page3: this.props.obj[0].magazine1.page3
                  }}
                  activePage={0}
                />
              </div>
            </div>
          </div>

          {/* 하단 네비게이션 */}
          <div className="flex items-center justify-between gap-3">
            <button
              type="button"
              disabled={this.state.enable ? false : true}
              className="inline-flex items-center gap-1 rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-600 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
              onClick={() => this.routeToNextPage("previous")}
            >
              ← 목록으로
            </button>
            <button
              type="button"
              disabled={this.state.enable ? false : true}
              className="inline-flex items-center gap-1 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600 disabled:cursor-not-allowed disabled:opacity-50"
              onClick={() => this.checkIfEmpty("next")}
            >
              다음 단계로 →
            </button>
          </div>

          {!this.state.enable && (
            <p className="mt-3 text-right text-xs text-gray-400">
              이미지를 업로드하는 중입니다. 잠시만 기다려 주세요…
            </p>
          )}
        </div>
      </div>
    );
  }

}
